import { useState } from "react";
import { Segment } from "semantic-ui-react";

import { TableOverlayLoader } from "components";
import { useRegisterNavAction } from "hooks";
import { InterventionChecklists, PIN_CHECKLISTS_TABS, PinChecklists, PinChecklistsTabs, ServiceChecklists } from "modules/PendingChecklistsDashboard/components";
import { useInterventionPendingChecklistsQuery } from "modules/PendingChecklistsDashboard/components/InterventionChecklists/hooks";
import { usePinPendingChecklistsQuery } from "modules/PendingChecklistsDashboard/components/PinChecklists/hooks";
import { useServicePendingChecklistsQuery } from "modules/PendingChecklistsDashboard/components/ServiceChecklists/hooks";
import { useChecklistsQuery } from "modules/PendingChecklistsDashboard/hooks";
import "modules/PendingChecklistsDashboard/PendingChecklistsDashboard.scss";

export const PendingChecklistsDashboard = () => {
  const [activeTab, setActiveTab] = useState(PIN_CHECKLISTS_TABS.PinChecklists);
  const { data: checklists, isLoading: isChecklistsLoading, refetch: refetchChecklists } = useChecklistsQuery();
  const { data: pinPendingChecklistsGroupedByPinType, isLoading: isPinPendingChecklistsLoading, refetch: refetchPinPendingChecklists } = usePinPendingChecklistsQuery();
  const {
    data: servicePendingChecklistsGrouped,
    isLoading: isServicePendingChecklistsLoading,
    refetch: refetchServicePendingChecklists
  } = useServicePendingChecklistsQuery();
  const {
    data: interventionPendingChecklistsGrouped,
    isLoading: isInterventionPendingChecklistsLoading,
    refetch: refetchInterventionPendingChecklists
  } = useInterventionPendingChecklistsQuery();

  useRegisterNavAction(() => {
    refetchChecklists();
    refetchPinPendingChecklists();
    refetchServicePendingChecklists();
    refetchInterventionPendingChecklists();
  });

  if (isChecklistsLoading || isPinPendingChecklistsLoading || isServicePendingChecklistsLoading || isInterventionPendingChecklistsLoading)
    return <TableOverlayLoader columnSize={3} pageSize={3} />;

  return (
    <div className="PendingChecklistsDashboard">
      <PinChecklistsTabs activeTab={activeTab} toggleActiveTab={(tab: PIN_CHECKLISTS_TABS) => setActiveTab(tab)} />

      <Segment attached="bottom">
        {activeTab === PIN_CHECKLISTS_TABS.PinChecklists && (
          <PinChecklists checklists={checklists} pinPendingChecklistsGroupedByPinType={pinPendingChecklistsGroupedByPinType} />
        )}
        {activeTab === PIN_CHECKLISTS_TABS.ServiceChecklists && (
          <ServiceChecklists checklists={checklists} isLoading={isServicePendingChecklistsLoading} servicePendingChecklistsGrouped={servicePendingChecklistsGrouped} />
        )}
        {activeTab === PIN_CHECKLISTS_TABS.InterventionsChecklists && (
          <InterventionChecklists
            checklists={checklists}
            isInterventionPendingChecklistsLoading={isInterventionPendingChecklistsLoading}
            interventionPendingChecklistsGrouped={interventionPendingChecklistsGrouped}
          />
        )}
      </Segment>
    </div>
  );
};
